import { useState } from 'react';
import type { BoPhan, DoiTuong, DonVi, KhoHang, Lo, VatTu, ViTri } from '@/types/schemas';

type DonViSearchValue = DonVi & { ma_unit?: string };

/**
 * Hook for managing search fields state
 * @returns Search fields state and handlers
 */
export const useSearchFieldsState = () => {
  // Original states (keeping for backward compatibility)
  const [selectedDepartment, setSelectedDepartment] = useState<BoPhan | null>(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState<KhoHang | null>(null);
  const [selectedObject, setSelectedObject] = useState<DoiTuong | null>(null);
  const [selectedProduct, setSelectedProduct] = useState<VatTu | null>(null);

  // New states for DetailTab
  const [selectedMaterial, setSelectedMaterial] = useState<VatTu | null>(null);
  const [selectedImportWarehouse, setSelectedImportWarehouse] = useState<KhoHang | null>(null);
  const [selectedFromPosition, setSelectedFromPosition] = useState<ViTri | null>(null);
  const [selectedToPosition, setSelectedToPosition] = useState<ViTri | null>(null);
  const [selectedLot, setSelectedLot] = useState<Lo | null>(null);
  const [selectedUnit, setSelectedUnit] = useState<DonViSearchValue | null>(null);

  const clearSearchFields = () => {
    setSelectedDepartment(null);
    setSelectedWarehouse(null);
    setSelectedObject(null);
    setSelectedProduct(null);
    setSelectedMaterial(null);
    setSelectedImportWarehouse(null);
    setSelectedFromPosition(null);
    setSelectedToPosition(null);
    setSelectedLot(null);
    setSelectedUnit(null);
  };

  return {
    // Original states
    selectedDepartment,
    setSelectedDepartment,
    selectedWarehouse,
    setSelectedWarehouse,
    selectedObject,
    setSelectedObject,
    selectedProduct,
    setSelectedProduct,

    // New states for DetailTab
    selectedMaterial,
    setSelectedMaterial,
    selectedImportWarehouse,
    setSelectedImportWarehouse,
    selectedFromPosition,
    setSelectedFromPosition,
    selectedToPosition,
    setSelectedToPosition,
    selectedLot,
    setSelectedLot,
    selectedUnit,
    setSelectedUnit,

    clearSearchFields
  };
};
